module.exports = __webpack_public_path__ + "static/media/maxilofacial-catalog.52363568.pdf";